import { FEEDS_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import feedsTypes from '../../constants/feedsTypes'
import { axios } from '../../services'

// 0 Sidebar helpers
// 1 archive
// 2 restore
// 3 destroy
// 4 Get Archive
// 5 Get Project Archive

// 0 Sidebar helpers
const show_archive_sidebar_feed_actions = () => {
  return {
    type: "SHOW_ARCHIVE_SIDEBAR_FEED_ACTIONS"
  }
}

const hide_archive_sidebar_feed_actions = () => {
  return {
    type: "HIDE_ARCHIVE_SIDEBAR_FEED_ACTIONS"
  }
}

// 1 archive = add to Trash
const archive_feed_request = () => {
  return {
    type: feedsTypes.archive.request
  }
}

const archive_feed_success = (response) => {
  return {
    type: feedsTypes.archive.success,
    payload: response.data
  }
}

const archive_feed_failure = (messages) => {
  return {
    type: feedsTypes.archive.failure,
    payload: messages
  }
}

const archive_feed = (feed_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( archive_feed_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.archive, {id: feed_id}),
      {
        page: page,
        per_page: 10
      }
    ).then( response => {
      // success
      dispatch( archive_feed_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error archiving feed."]
      }
      dispatch( archive_feed_failure( errors ) )
    })
  }
}

// 2 restore = from Trash back to active
const restore_feed_request = () => {
  return {
    type: feedsTypes.restore.request
  }
}

const restore_feed_success = (response) => {
  return {
    type: feedsTypes.restore.success,
    payload: response.data
  }
}

const restore_feed_minimal_success = (response) => {
  return {
    type: feedsTypes.restore.success_minimal,
    payload: response.data
  }
}

const restore_feed_failure = (messages) => {
  return {
    type: feedsTypes.restore.failure,
    payload: messages
  }
}

const restore_feed = (feed_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( restore_feed_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.restore, {id: feed_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( restore_feed_minimal_success(response) )
      } else {
        dispatch( restore_feed_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error restoring feed."]
      }
      dispatch( restore_feed_failure( errors ) )
    })
  }
}

// 3 destroy = permanently delete
const destroy_feed_request = () => {
  return {
    type: feedsTypes.destroy.request
  }
}

const destroy_feed_success = (response) => {
  return {
    type: feedsTypes.destroy.success,
    payload: response.data
  }
}

const destroy_feed_failure = (messages) => {
  return {
    type: feedsTypes.destroy.failure,
    payload: messages
  }
}

const destroy_feed = (feed_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( destroy_feed_request() )

    // Request
    axios.delete(
      formatRoute(FEEDS_ROUTES.destroy, {id: feed_id}),
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( destroy_feed_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error destroying feed."]
      }
      dispatch( destroy_feed_failure( errors ) )
    })
  }
}

// 4 Get Archive
const feeds_archive_request = () => {
  return {
    type: feedsTypes.index.request
  }
}

const feeds_archive_success = (response) => {
  return {
    type: feedsTypes.index.success,
    payload: response.data
  }
}

const feeds_archive_failure = (messages) => {
  return {
    type: feedsTypes.index.failure,
    payload: messages
  }
}

const feeds_archive = (page=1) => {
  return function (dispatch) {
    // Before Request
    dispatch(feeds_archive_request())

    // Request
    axios.get(
      FEEDS_ROUTES.archive_index,
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( feeds_archive_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feeds."]
      }
      dispatch( feeds_archive_failure(errors))
    })
  }
}

// 5 Get Project Archive
const project_archive_request = () => {
  return {
    type: feedsTypes.project_archive.request
  }
}

const project_archive_success = (response) => {
  return {
    type: feedsTypes.project_archive.success,
    payload: response.data
  }
}

const project_archive_failure = (messages) => {
  return {
    type: feedsTypes.project_archive.failure,
    payload: messages
  }
}

const project_archive = (feed_id, page=1) =>{
  return function (dispatch) {
    // Before Request
    dispatch(project_archive_request())

    // Request
    axios.get(
      formatRoute(FEEDS_ROUTES.archive, {id: feed_id}),
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( project_archive_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        // errors = ["Error fetching archived feeds."]
        errors = [error]
      }
      dispatch( project_archive_failure(errors))
    })
  }
}


export {
  show_archive_sidebar_feed_actions,
  hide_archive_sidebar_feed_actions,
  archive_feed,
  restore_feed,
  destroy_feed,
  feeds_archive,
  project_archive
}



// WEBPACK FOOTER //
// ./src/js/actions/feeds/archive_actions.js